import { render, staticRenderFns } from "./TaskParamsForm.vue?vue&type=template&id=09404ceb"
import script from "./TaskParamsForm.vue?vue&type=script&lang=js"
export * from "./TaskParamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports